// animation.ts
export const luxuryEase = [0.16, 1, 0.3, 1];

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
};

export const fadeSlow = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};
